import type { AxiosInstance } from 'axios'
import axios from 'axios'
import { MaxTimeoutMs } from '~/constants/api'
import { getAccessToken } from '~/api/client/oidcClient'

const baseUrl = import.meta.env.VITE_ACTIVITY_EVENT_PROXY

export const activityEventClient: AxiosInstance = axios.create({
  timeout: MaxTimeoutMs,
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  transformRequest: [(data, headers) => {
    headers.Authorization = `Bearer ${getAccessToken()}`
    return JSON.stringify(data)
  }],
})
